"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MasteringTheArtOfHardscape() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223289" id="pourquoi-choisir-sahel-forwarding-why-us" className="w-full bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col lg:flex-row overflow-hidden rounded-lg shadow-lg border border-border bg-card">
          
          {}
          <div className="w-full lg:w-[60%] relative min-h-[400px] lg:min-h-[600px] group overflow-hidden bg-muted">
            {}
            <img src="https://eternal-donkey.10web.cloud/wp-content/uploads/2026/04/le-port-de-dakar.jpg" alt="Logistics professional in Dakar reviewing transport documentation" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
            
            {}
            <div className="absolute inset-0 bg-primary/10 transition-opacity duration-700 group-hover:bg-primary/40" />
            
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/bogolan_pattern_overlay.png" alt="Subtle Bogolan geometric pattern watermark" className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 ease-in-out group-hover:opacity-90 mix-blend-screen pointer-events-none" />
          </div>

          {}
          <div ref={ref} className={`w-full lg:w-[40%] flex flex-col justify-center p-8 md:p-12 lg:p-16 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary mb-6 tracking-tight">Pourquoi Choisir Sahel Forwarding Services ?</h2>
            
            <div className="space-y-6 text-muted-foreground font-default text-lg leading-relaxed">
              <p>
                L'avantage F2S réside dans notre maîtrise absolue du terrain ouest-africain. Basés à Dakar, nous transformons les défis logistiques complexes en solutions fluides grâce à notre connaissance approfondie des corridors régionaux.
              </p>
              <p>
                De l'intégration numérique des douanes à notre réseau multimodal, nous assurons une fiabilité totale. Nous allions rigueur internationale et expertise locale pour garantir l'intégrité de vos marchandises à chaque étape.
              </p>
            </div>
            
            <div className="mt-10">
              <Button asChild size="lg" className="group/btn bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-md">
                <Link to="#">
                  Nos Expertises / Our Expertise
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}